var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 7.00066L12 3.00066L13 3.00074C17.97 3.00115 21.9997 7.03148 21.9993 12.0015C21.9989 16.9715 17.9685 21.0011 12.9985 21.0007C8.01852 21.0003 3.99885 16.97 3.99926 12C3.9995 9.05 5.41972 6.45012 7.60985 4.8103L7.60985 4.7903L14.4093 11.5909L12.9992 13.0007L7.57962 7.58029C6.58953 8.78021 5.9994 10.3202 5.99926 12.0002C5.99895 15.8702 9.12869 19.0004 12.9987 19.0007C16.8687 19.0011 19.9989 15.8713 19.9993 12.0013C19.9996 8.47131 17.3898 5.5711 13.9998 5.08082L13.9997 7.00082L11.9997 7.00066ZM12.9988 18.0007C12.4488 18.0007 11.9988 17.5507 11.9989 17.0007C11.9989 16.4507 12.4489 16.0007 12.9989 16.0007C13.5489 16.0008 13.9989 16.4508 13.9989 17.0008C13.9988 17.5508 13.5488 18.0008 12.9988 18.0007ZM18.9993 12.0012C18.9993 11.4512 18.5493 11.0012 17.9993 11.0011C17.4493 11.0011 16.9993 11.4511 16.9993 12.0011C16.9992 12.5511 17.4492 13.0011 17.9992 13.0011C18.5492 13.0012 18.9992 12.5512 18.9993 12.0012ZM7.99918 13.0003C7.44918 13.0003 6.99922 12.5502 6.99926 12.0002C6.99931 11.4502 7.44934 11.0003 7.99934 11.0003C8.54934 11.0004 8.99931 11.4504 8.99926 12.0004C8.99922 12.5504 8.54918 13.0004 7.99918 13.0003Z",
    fill: "#5AC17F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer24Px);
export default __webpack_public_path__ + "static/media/timer_24px.012d0e19f40403d6e6be37054b3907c1.svg";
export { ForwardRef as ReactComponent };